import axios from "axios";
import { Toast as showToast } from "core/components/global/toast/toast";
import { fetchBaseProxyUrl } from "core/utils/common";


const baseURL = fetchBaseProxyUrl({});

export const getFavorites = async (amsBearerToken) => {
  try {
    if (amsBearerToken) {
      const response: any = await axios.request({
        method: "GET",
        url: `${baseURL}/api/favorites`,
        headers: {
          Authorization: amsBearerToken,
        }
      });

      if (response.status < 300) {
        return response.data["favorites"];
      } else {
        return [];
      }
    } else {
      return [];
    }
  } catch (error) {
    
    return null;
  }
};

export const updateFavorites = async (amsBearerToken, targetName) => {
  console.log(`updateFavorites: ${targetName}`)
  console.log(`updateFavorites: ${amsBearerToken}`)
  try {
    if (amsBearerToken) {
      const response: any = await axios.request({
        method: "POST",
        url: `${baseURL}/api/favorites`,
        headers: {
          "Content-Type": "application/json",
          Authorization: amsBearerToken,
        },
        data: {
          targetName: targetName
        },
      });

      console.log(`updateFavorites response: ${JSON.stringify(response.data["favorite"])}`);

      if (response.status < 300) {
        const response_data = response.data["favorite"];
        console.log(`1: ${JSON.stringify(response_data)}`);
        return(response_data);
      } else {
        console.log(2);
        showToast(response.message, "error");
        return(null);
      }
    } else {
      console.log(3);
      return null;
    }
  } catch (error) {
    console.log(4);
    
    return null;
  }
};

export const deleteFavorites = async (amsBearerToken, model) => {
  try {
    if (amsBearerToken) {
      const response: any = await axios.request({
        method: "DELETE",
        url: `${baseURL}/api/favorites/${model}`,
        headers: {
          "Content-Type": "application/json",
          authorization: amsBearerToken,
        },
      });
      if (response.status === 200) {
        showToast(response.message, "success");
        return(true);
      } else {
        showToast(response.message, "error");
        return(true);
      }
    } else {
      return(null);
    }
  } catch (error) {
    
    return(null);
  }
};
